import { Card, Statistic, Typography } from 'antd';

import type {
	MaterialMovementReport,
	MovementAction,
} from '../../../../redux/api/material-movements';
import {
	ACTION_META,
	CORE_ACTIONS,
} from '../../../../components/MaterialMovements/movementMeta';

const { Text } = Typography;

interface SummaryCardsProps {
	summary: MaterialMovementReport['summary'];
	selected: MovementAction[];
	onToggle: (action: MovementAction) => void;
}

/**
 * One card per action. Counts ignore the action filter (the server computes
 * them that way), so selecting "Cut" does not zero out every other card.
 */
const SummaryCards = ({ summary, selected, onToggle }: SummaryCardsProps) => {
	const visible = summary.by_action.filter(
		(row) => CORE_ACTIONS.includes(row.action) || row.transactions > 0
	);

	return (
		<div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
			{visible.map((row) => {
				const meta = ACTION_META[row.action];
				const active = selected.includes(row.action);
				return (
					<Card
						key={row.action}
						size="small"
						hoverable
						data-testid={`movement-summary-${row.action}`}
						aria-pressed={active}
						role="button"
						tabIndex={0}
						onClick={() => onToggle(row.action)}
						onKeyDown={(event) => {
							if (event.key === 'Enter' || event.key === ' ') {
								event.preventDefault();
								onToggle(row.action);
							}
						}}
						className={`shadow-sm ${active ? 'border-blue-500 ring-1 ring-blue-500' : ''}`}
					>
						<Statistic
							title={
								<span className="flex items-center gap-1.5">
									{meta?.icon}
									{meta?.label ?? row.label}
								</span>
							}
							value={row.transactions}
						/>
						<Text type="secondary" className="text-xs">
							{row.bars} {row.bars === 1 ? 'bar' : 'bars'}
						</Text>
					</Card>
				);
			})}
		</div>
	);
};

export default SummaryCards;
